import { DomainSwitch } from "_components/Abstractions/DomainSwitch";
import { LoadingWastesForm } from "./WasteDetails/LoadingWastesForm";
import { ContainersExchangeForm } from "./WasteDetails/ContainersExchangeForm";
import { SaleWastesDetailsForm, TransportWastesDetailsForm } from "./WasteDetails/SaleWastesDetailsForm";
import { FormControl } from "_components/Forms/FormControl";
import { useContext, useEffect } from "react";
import { OrderContext } from "./MainForms/OrderContext";
import { useFormContext } from "react-hook-form";
import { HorizontalView } from "../Abstractions/HorizontalView";
import { OrderServicesForm } from "./WasteDetails/OrderServicesForm";

export function WastesOrderDetails({ transactionType, includeExtendedSaleWastesData, isUpdate = false }) {
  const isPurchase = transactionType === "Purchase";
  const isSale = transactionType === "Sale";
  const isTransport = transactionType === "Transport";
  const { addressId, isBdoIntegrated, isWasteTransport, isSeries, isAddressBdoLinked,
    hasAddressLoadingWastes, hasAddressUsedContainers} = useContext(OrderContext);
  const fillWasteMass = isUpdate && !isSeries;

  const { setValue } = useFormContext();

  useEffect(() => {
    if(!isBdoIntegrated && isSale) {
      setValue("wastesDetails.generateKpoCards", false);
    }
  }, [isBdoIntegrated, isSale]);

  useEffect(() => {
    if(isAddressBdoLinked !== undefined && isBdoIntegrated !== isAddressBdoLinked) {
      setValue("wastesDetails.isBdoIntegrated", isAddressBdoLinked);
    }
  }, [isAddressBdoLinked]);

  useEffect(() => {
    if(!isPurchase || isUpdate) {
      return;
    }

    if (!addressId) {
      setValue("wastesDetails.isLoading", false);
      setValue("wastesDetails.isContainerExchange", false);
      return;
    }

    if (hasAddressLoadingWastes !== undefined) {
      setValue("wastesDetails.isLoading", hasAddressLoadingWastes ? true : !hasAddressUsedContainers);
    }
    if (hasAddressUsedContainers !== undefined) {
      setValue("wastesDetails.isContainerExchange", hasAddressUsedContainers);
    }
  }, [addressId, hasAddressLoadingWastes, hasAddressUsedContainers])

  return (
    <div className="mb-2">
      <div className="d-flex gap-4">
        <DomainSwitch label="Zlecenie BDO" name="wastesDetails.isBdoIntegrated"/>
        {isSale && isBdoIntegrated && !isUpdate && <DomainSwitch label="Generuj karty KPO" name="wastesDetails.generateKpoCards"/>}
        {isTransport && <DomainSwitch label="Transport z TRK" name="wastesDetails.isWasteTransport"/>}
        {isPurchase && (
          <>
            <DomainSwitch label="Załadunek" name="wastesDetails.isLoading" readonly={!addressId}/>
            <DomainSwitch label="Wymiana kontenerów" name="wastesDetails.isContainerExchange" readonly={!addressId}/>
          </>
        )}
      </div>
      {(isPurchase || isWasteTransport) && <HorizontalView>
        <FormControl name="wastesDetails.receivedNoteNumber" label="Nr. PZ" required={false}/>
         <FormControl name="wastesDetails.internalInvoiceNumber" label="Nr. faktury zakupu" required={false}/>
      </HorizontalView>}
      {(isSale || isWasteTransport) && <HorizontalView>
        <FormControl name="wastesDetails.deliveryNoteNumber" label="Nr. WZ" required={false}/>
        <FormControl name="wastesDetails.externalInvoiceNumber" label="Nr. faktury sprzedaży" required={false}/>
      </HorizontalView>}
      <h6>Towary</h6>
      <LoadingWastesForm fillWasteMass={fillWasteMass}/>
      <ContainersExchangeForm fillWasteMass={fillWasteMass}/>
      {isSale && <SaleWastesDetailsForm fillWasteMass={fillWasteMass} includeExtendedSaleWastesData={includeExtendedSaleWastesData}/>}
      {isTransport && <TransportWastesDetailsForm fillWasteMass={fillWasteMass}/>}
      <hr/>
      <h6 className="mt-2">Usługi</h6>
      <OrderServicesForm fillWasteMass={fillWasteMass} />
    </div>
  );
}
